"use client";

import Image from "next/image";
import Link from "next/link";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";
import "./style.css";

interface PickItem {
  title: string;
  imageSrc: string;
  link: string;
}

interface ExchangeAndWallletsProps {
  picks: PickItem[];
}

export default function ExchangeAndWalllets({
  picks,
}: ExchangeAndWallletsProps) {
  const [mounted, setMounted] = useState(false);
  const { resolvedTheme } = useTheme();
  const isDark = mounted ? resolvedTheme === "dark" : false;

  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <div className="p-3 gh-sidebar-main gh-sidebar-crypto-platforms gh-sidebar-crypto-platforms rounded-3 mb-4">
      <h3 className="w-100 fw-bold fs-5 mb-2">Best Exchanges & Wallets</h3>

      <p className="mb-4 px-md-3" style={{ fontSize: "14px" }}>
        Informative content with affiliate links.{" "}
        <Link
          href="/terms-of-services"
          style={{
            color: isDark ? "#ffffff" : "#000000",
            textDecoration: "underline",
          }}
        >
          Disclaimer →
        </Link>
      </p>

      <div className="d-flex flex-column gap-2 px-md-3 w-100">
        {picks.map((pick, index) => (
          <div
            key={index}
            className="p-2 rounded-3"
            style={{ background: "#97A3AF24" }}
          >
            {index === 0 && (
              <div
                style={{ color: "#8e8f91", fontSize: "12px" }}
                className="text-uppercase fw-semibold px-2"
              >
                Editor's Pick
                <hr className="py-0 my-2" />
              </div>
            )}

            <div className="d-flex align-items-center justify-content-between gap-2">
              {/* LEFT: Image + Title */}
              <div className="d-flex align-items-center gap-2">
                <Image
                  src={pick.imageSrc}
                  alt={pick.title}
                  width={40}
                  height={40}
                  style={{ borderRadius: "10px", objectFit: "cover" }}
                  priority
                  fetchPriority="high"
                />
                <h4 className="mb-0 fs-6">{pick.title}</h4>
              </div>

              {/* RIGHT: Discover link */}
              <Link
                href={pick.link}
                target="_blank"
                className="d-flex align-items-center gap-1 fw-semibold text-decoration-none"
                style={{ color: "#f19021", whiteSpace: "nowrap" }}
              >
                Discover
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#f19021"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="5" y1="12" x2="19" y2="12" />
                  <polyline points="12 5 19 12 12 19" />
                </svg>
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
